(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ant_carousell"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousel(root) {
      if (!root) return;

      var track = root.querySelector('.custom-carousel__track');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;

      var prevBtn = root.querySelector('.custom-carousel__arrow--prev');
      var nextBtn = root.querySelector('.custom-carousel__arrow--next');
      var dotsContainer = root.querySelector('.custom-carousel__dots');

      var index = 0;

      function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'custom-carousel__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('data-index', String(i));
          dot.setAttribute('aria-label', 'Vai alla slide ' + (i + 1));
          dotsContainer.appendChild(dot);
        });
      }

      function getDots() {
        return Array.prototype.slice.call(
          root.querySelectorAll('.custom-carousel__dot')
        );
      }

      function update() {
        var offset = -index * 100;
        track.style.transform = 'translateX(' + offset + '%)';

        var dots = getDots();
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function goTo(newIndex) {
        if (newIndex < 0) {
          newIndex = slides.length - 1;
        }
        if (newIndex >= slides.length) {
          newIndex = 0;
        }
        index = newIndex;
        update();
      }

      if (slides.length <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        if (dotsContainer) dotsContainer.style.display = 'none';
        return;
      }

      buildDots();

      if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(index - 1);
        });

        nextBtn.addEventListener('click', function () {
          goTo(index + 1);
        });
      }

      if (dotsContainer) {
        dotsContainer.addEventListener('click', function (event) {
          var target = event.target;
          if (!(target instanceof HTMLElement)) return;
          if (!target.classList.contains('custom-carousel__dot')) return;
          var i = Number(target.getAttribute('data-index'));
          if (!Number.isNaN(i)) {
            goTo(i);
          }
        });
      }

      update();
    }

    function initAllCarousels(container) {
      var root = container || document;
      var carousels = root.querySelectorAll('.custom-carousel');
      carousels.forEach(function (carousel) {
        initCarousel(carousel);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initAllCarousels(document);
    });

    document.addEventListener('shopify:block:load', function (event) {
      initAllCarousels(event.target);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAllCarousels(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
